/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from "react-router-dom";
import {CompanyResponse} from "@providers/company/_models";
import {observer} from "mobx-react";
import {image_default, JUNIOR_CASHIER} from "@utils/constants";
import {employeeStore} from "@store/employee";
import {Company} from "@providers/company/_request";
import {roleRoutingAdmin} from "@utils/index";

type Props = {
  company: CompanyResponse
}

const UserInfoCell: FC<Props> = observer(({company}) => {

    return (
        <div className='d-flex align-items-center'>
            {/* begin:: Avatar */}
            <div className='me-3'>

                <Link to={`/${company.id}/dashboard-merchant`}>
                    <div className='d-flex align-items-center w-200px'>
                        <div className='logo-table'>
                            <img src={company?.logoFile?Company.getFiles(company?.logoFile):`/${image_default}`}/>
                        </div>
                        <span style={{textOverflow:'ellipsis', overflow:'hidden', whiteSpace:'nowrap'}}>{company.name}</span>
                    </div>

                </Link>
            </div>
        </div>
    )
})

export {UserInfoCell}
